import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

import { getRulesContent } from "../../content/content.selectors";

import { ContentSection, ContentBlock } from "../components";
import ContentListContainer from "../../content/components/ContentListContainer";

import Button from "../../../ui/button/Button";
import { Localize } from "../../../locale/localization";

class RulesAdminPage extends Component {
  renderHeaderActions() {
    return (
      <NavLink to="/admin/rules/add">
        <Button icon="#plus">
          {Localize("rules.create")}
        </Button>
      </NavLink>
    );
  }

  render() {
    let { items } = this.props;
    items = items.map(item =>
      Object.assign({}, item, {
        channel: (item.channel && item.channel.name) || ""
      })
    );
    return (
      <ContentSection>
        <ContentBlock
          title={Localize("rules.header")}
          renderActions={this.renderHeaderActions}
        >
          <ContentListContainer contents={items} type="rules" />
        </ContentBlock>
      </ContentSection>
    );
  }
}

const mapStateToProps = state => {
  const items = getRulesContent(state);
  return {
    items
  };
};

const ConnectedRulesAdminPage = connect(mapStateToProps, null)(RulesAdminPage);

export default ConnectedRulesAdminPage;



// WEBPACK FOOTER //
// ./src/modules/pages/admin/RulesAdminPage.js